import { createFileRoute } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { Skeleton } from '@ouropix/ui';
import { useAlert } from '@/hooks/useAlerts';
import { AlertDetailPanel } from '@/components/alerts/AlertDetailPanel';

export const Route = createFileRoute('/_admin/alertas-seguranca/$id')({
  component: AlertDetailPage,
});

function AlertDetailPage() {
  const { id } = Route.useParams();
  const { data: alert, isLoading, error } = useAlert(id);

  if (isLoading) {
    return (
      <div className="space-y-4 p-4 md:p-6">
        <Skeleton className="h-8 w-32" />
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }

  if (error || !alert) {
    return (
      <div className="flex flex-col items-center justify-center py-24 gap-3 p-6">
        <ShieldAlert className="h-12 w-12 text-muted-foreground" aria-hidden="true" />
        <p className="text-lg font-semibold">Alerta nao encontrado</p>
        <p className="text-sm text-muted-foreground">
          O alerta com ID{' '}
          <code className="font-mono text-xs bg-muted px-1.5 py-0.5 rounded">{id}</code> nao
          existe ou voce nao tem permissao para visualiza-lo.
        </p>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6">
      <AlertDetailPanel alert={alert} showBackButton />
    </div>
  );
}
